import { connect } from 'react-redux'

import { getManipulationList } from '../../../modules/manipulations'

import Component from './Manipulations'

const mapActionCreators = {
  getManipulationList,
}

const mapStateToProps = (state) => ({
  manipulationList: state.manipulations.get('manipulationList'),
  manipulationCount: state.manipulations.get('manipulationCount'),
  isFetching: state.manipulations.get('isFetching'),
})

export default connect(mapStateToProps, mapActionCreators)(Component)



// WEBPACK FOOTER //
// ./src/containers/manipulations/list/index.js